import { CRAService, CRAProvider, HttpService } from '@lk/api'

export const makeCRAService = (http: HttpService, baseUrl: string) => new CRAService(new CRAProvider(http, baseUrl))
